import { TPaginate } from '@@types/base';
import instance from '@apis/instance';
import { IRefund, TRefundApplication } from 'interfaces/refund';
import { invalidateGetResponse } from 'utils/common';

const BASE_REFUND_URL = '/refund';

const fetchRefunds = (queryParams: Record<string, string>) =>
  invalidateGetResponse<TPaginate<IRefund>>({
    url: BASE_REFUND_URL,
    options: { params: queryParams },
  });

const applyForRefund = (refundData: TRefundApplication) =>
  instance.post(BASE_REFUND_URL, refundData);

const cancelRefund = (refundId: string) =>
  instance.patch(`${BASE_REFUND_URL}/cancel/${refundId}`);

export default {
  fetchRefunds,
  applyForRefund,
  cancelRefund,
};
